module.exports = __webpack_public_path__ + "static/media/ic-recommendation-mobile-ex.82498790.png";